import {
  Button,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
  Text,
  Box,
} from '@chakra-ui/react'
import { Modal } from '@chakra-ui/modal'
import { useEffect } from 'react'
import { FormGroup } from 'react-bootstrap'
import { FormLabel } from '@chakra-ui/form-control'
import { Flex } from '@chakra-ui/layout'
import { user } from '../../../helpers/user'
import { baseURL } from '../../../services/api'
import { Select } from '@chakra-ui/select'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from 'react-query'
import {
  editInfoBatidas,
  editInfoGravacao,
  editInfoPrazoEntrega,
  editInfoProductColor,
  editInfoQuantidadeProduct,
  editInfoValorUnitario,
  editPrecoBase,
  listarCoresDisponiveis,
} from '../requests'
import { FaEdit } from 'react-icons/fa'

export function EditItem({ item, refetch }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  console.log(item)

  const { handleSubmit, register, setValue } = useForm()

  useEffect(() => {
    setValue('valorUnitario', item.VALOR_UNIT)
    setValue('quantidade', item.QTDNEG)
    setValue('prazoEntrega', item.PRAZO_ENTREGA)
    setValue('gravacao', item?.DS_IMPR?.codigo_cor)
    setValue('batidas', item.AD_QTDBATIDA)
    setValue('cor', item?.DS_COR?.codigo_cor)
    setValue('precoBase', item.PRECO_BASE)
  }, [isOpen])

  const { data: cores } = useQuery({
    queryFn: async () => {
      const cores = await listarCoresDisponiveis(item.CODPROD)
      return {
        cores,
      }
    },
    queryKey: ['get-info-selects', item.CODPROD],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 3,
  })

  const { data: gravacoes } = useQuery({
    queryFn: async () => {
      const { data } = await baseURL.get(`/detalhes-produto/lista-impressoes-gerais/${item.CODPROD}`)
      return {
        gravacoes: data,
      }
    },
    queryKey: ['get-info-selects-inp', item.CODPROD],
    refetchOnWindowFocus: false,
  })

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (data) => {
      const valorTotal = data.valorUnitario * parseInt(data.quantidade)

      await Promise.all([
        editInfoValorUnitario(data.valorUnitario, valorTotal, item),
        editInfoPrazoEntrega(data.prazoEntrega, item),
        editInfoGravacao(data.gravacao, item),
        editInfoBatidas(data.batidas, item),
        editInfoQuantidadeProduct(data.valorUnitario, data.quantidade, valorTotal, item, user.codigo_usuario),
        editInfoProductColor(data.cor, item),
        editPrecoBase(data.precoBase, item),
      ])
    },
    onSuccess: () => {
      refetch()
      toast({
        title: 'Item editado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao editar item',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleEditItem(data) {
    try {
      await mutateAsync(data)

      onClose()
    } catch (error) {
      console.log(error)
    }
  }

  const optionsEntrega = Array.from({ length: 10 }).map((_, index) => {
    return {
      value: index + 1,
      label: `${index + 1} dias`,
    }
  })

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center" flexDir="column" cursor={'pointer'}>
        <Text fontSize="14px">Editar</Text>
        <FaEdit onClick={onOpen} size={30} color="#7FBC03" />
      </Box>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(handleEditItem)}>
          <ModalHeader>
            <h1>
              Editar <span>{item.NOME}</span>
            </h1>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDir={'column'} gap={3} width={'100%'}>
              <FormGroup>
                <FormLabel htmlFor="precoBase">Preço Base</FormLabel>
                <Input id="precoBase" placeholder="Preço Base" {...register('precoBase')} />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="valorUnitario">Valor unitário</FormLabel>
                <Input id="valorUnitario" placeholder="Valor unitário" {...register('valorUnitario')} />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="quantidade">Quantidade</FormLabel>
                <Input id="quantidade" placeholder="Quantidade" {...register('quantidade')} />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="cor">Cor</FormLabel>
                <Select id="cor" placeholder="Cor" {...register('cor')}>
                  {cores?.cores?.map((cor) => (
                    <option key={cor.codigo_cor} value={cor.codigo_cor}>
                      {cor.descricao_cor}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="prazo">Prazo Entrega</FormLabel>
                {/* <Input
                  id="prazo"
                  placeholder="Prazo entrega"
                  {...register("prazoEntrega")}
                /> */}
                <Select id="prazo" placeholder="Prazo entrega" {...register('prazoEntrega')}>
                  {optionsEntrega.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="gravacao">Gravação</FormLabel>
                <Select id="gravacao" placeholder="Gravação" {...register('gravacao')}>
                  {gravacoes?.gravacoes?.map((gravacao, index) => (
                    <option key={index} value={gravacao.codigo_impressao}>
                      {gravacao.descricao_impressao}
                    </option>
                  ))}
                </Select>
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="batidas">Batidas</FormLabel>
                <Input id="batidas" placeholder="Batidas" {...register('batidas')} />
              </FormGroup>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose} variant="ghost">
              Fechar
            </Button>
            <Button bg={'#7FBC03'} _hover={{ bg: '#7FBC03' }} color={'white'} isLoading={isLoading} loadingText="Editando item" type="submit">
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
